import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import user from './modules/user'
import permission from './modules/permission'
import leftAside from './modules/leftAside'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user,
    leftAside,
    permission
  },
  getters
})



// WEBPACK FOOTER //
// ./src/store/index.js